
import { mapGetters } from 'vuex'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import { copyToClip } from '~/utils/index'
import { decrypt } from '~/utils/secret'
import { dirtyHTML } from '@/utils/filter-dirty-html'
import { groupMembership } from '@/plugins/imMethod'
export default {
    components: {
        ElImageViewer
    },
    props: ['item'],
    data () {
        return {
            showCopyType: [
                'BUYER_CHECK_NUMBER', // 买家上号验号
                'CHANGE_TIES' // 请双方开始换绑
            ],
            showPreview: false,
            previewImages: [],
            previewImagesIndex: 0,
            richTextObj: {
                maxHeight: 300,
                openFlag: false,
                showBtnFlag: false
            }
        }
    },
    computed: {
        ...mapGetters({
            userinfo: 'user/userinfo'
        })
    },
    mounted () {
        this.$nextTick(() => {
            const richText = this.$refs.richText
            if (!richText) { return }
            const curHeight = richText.offsetHeight
            this.richTextObj.openFlag = curHeight > this.richTextObj.maxHeight
            this.richTextObj.showBtnFlag = curHeight > this.richTextObj.maxHeight
            this.previewImages = this.getImgSrc(this.item.content.content.richText)
        })
    },
    methods: {
        groupMembership,
        /**
         * 解决 xss
         */
        filterHtmlStr (htmlStr) {
            return dirtyHTML(htmlStr)
        },
        /**
         * 关闭图片展示
         */
        onCloseViewer () {
            this.showPreview = false
        },
        /**
         * 预览图片
         */
        onShowImg (event) {
            if (event.target.nodeName !== 'IMG') { return }
            const imgUrl = event.target.src
            this.previewImagesIndex = this.previewImages.findIndex(item => item === imgUrl)
            this.$nextTick(() => {
                this.showPreview = true
            })
        },
        /**
         * 获取图片列表
         */
        getImgSrc (richtext) {
            const imgList = []
            richtext.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/g, (match, capture) => {
                imgList.push(capture)
            })
            return imgList
        },
        /**
         * 工单卡片按钮点击事件
         */
        workOrderClick (item, items, index) {
            this.$emit('workOrderClick', item, items, index)
        },

        /**
         * 复制
         */
        copyPayNum (val) {
            copyToClip(val, '已复制')
        },
        /**
         * 处理图片
         */
        splitImg (val = '') {
            if (val.includes(',')) {
                const b = val.split(',')
                return (val = b)
            } else {
                return [val]
            }
        },
        /**
         * 处理密码加密解密
         */
        getPdwValue (val) {
            let data = val.value
            if (val.fieldType == 'PASSWORD') {
                data = decrypt(val.value)
            }
            if (val.fieldType == 'ACCOUNT') {
                data = decrypt(val.value)
            }
            return data
        }
    }
}
